import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { STATUS_CONFIG, TASK_STATUS_CYCLE, TaskStatus } from '../../types/work';

interface Props {
  status: string;
  clickable?: boolean;
  onCycle?: (newStatus: TaskStatus) => void;
  size?: 'sm' | 'md';
}

export const WorkStatusBadge: React.FC<Props> = ({ status, clickable, onCycle, size = 'sm' }) => {
  const { darkMode } = useTheme();
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;
  const classes = darkMode ? config.dark : config.light;
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!clickable || !onCycle) return;
    const idx = TASK_STATUS_CYCLE.indexOf(status as TaskStatus);
    const next = TASK_STATUS_CYCLE[(idx + 1) % TASK_STATUS_CYCLE.length];
    onCycle(next);
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium transition-all ${classes} ${sizeClasses} ${clickable ? 'cursor-pointer hover:ring-1 hover:ring-white/20' : ''}`}
      onClick={clickable ? handleClick : undefined}
      title={clickable ? 'Click to change status' : status.replace(/_/g, ' ')}
    >
      <span className="text-[10px]">{config.icon}</span>
      {status.replace(/_/g, ' ')}
    </span>
  );
};
